import(/* webpackMode: "eager" */ "/app/src/app/(kz)/(main)/error.tsx");
